<template>
    <div class="my-service">
      <v-loading :loading="loading"></v-loading>
      <div class="my-service__header flex flex--align-center flex--justify-between">
        <v-item-title title="我的服务"></v-item-title>
        <v-icon type="iconarrow_circle_down-24px1"
                v-if="serviceList.length"
                @click.native="handleRecordShow"
                right-text="调用记录查询"></v-icon>
      </div>
      <user-service
        :list="serviceItemList"
        :serviceList="serviceList"
        :total="total"
        @update-service-item-list="handleUpdateServiceItemList"
      ></user-service>
      <ServerRecord
        :serviceList="serviceList"
        :visible.sync="recordVisible"></ServerRecord>
    </div>
</template>

<script>
import { getBuyService, getMyServiceData } from '@/api/application/service';
import UserService from "@/components/b-components/userService/userService.vue";
import ServerRecord from './serverRecord.vue';

export default {
  components: {
    UserService,
    ServerRecord,
  },
  data() {
    return {      
      serviceItemList: [],
      serviceList: [],
      loading: false,
      total: 0,      
      recordVisible: false,
    };
  },
  created() {
    this.getBuyService();
  },
  methods: {
    async getBuyService() {
      this.loading = true;
      const res = await getBuyService({
        finished: 1,
      });
      if (res) {
        this.serviceList = res.map((item) => Object.assign(item, {
          id: String(item.id),
        }));
      }
      this.loading = false;
    },
    async handleUpdateServiceItemList(params) {
      this.loading = true;
      const res = await getMyServiceData(params);
      if (res) {
        this.serviceItemList = res.data_list;
        this.total = res.total;
      }
        this.loading = false;
    },
    handleRecordShow() {
      this.recordVisible = true;
    },
  },
};
</script>

<style lang="less">
  @prefix: ~'my-service';

  .@{prefix}{
    padding: 16px 0;
    position: relative;
    height: 100%;
    &__header{
      padding: 0 16px;
      margin-bottom: 10px;
      .v-icon{
        color: rgba(0, 0, 0, 0.54);
        &:hover{
          cursor: pointer;
          color: @primary-color;
        }
        .icon-right-text{
          font-weight: 500;
        }
      }
    }
  }
</style>
